export default __webpack_public_path__ + "static/media/breakfast.cefae5c5.svg";